import Container from "react-bootstrap/Container"
import projectStyles from '../styles/Projects.module.css'
import ProjectsList from "../components/Projects/ProjectsList"
import Meta from "../components/Meta"
import { server } from "../config"
import { useAuth } from "../contexts/Auth"
import { supabase } from "../utils/supabaseClient"


export async function getServerSideProps() {
  const { data: projects, error } = await supabase.from("main_project").select().order('id', { ascending: true })
  error && console.log(error)
  return {
    props: {
      projects
    },
  };
}

export default function Projects(props){

    return(
        <>
          <Meta 
            title='Start a Side Project' 
            description="Click on a template below to get your side project started today." 
            keywords='' 
          />
          <Container className="py-5">
              <h6 className={projectStyles.header}>Unlock a template below to get your side project started</h6>  
              <br /> <br />
              <ProjectsList projects={props.projects}/>
          </Container>
        </>
    )
}